<template>
  <div class="step">
    <span class="num">{{ num }}</span>
    <span class="text" v-html="text"></span>
  </div>
</template>

<script>
export default {
  name: 'ArtClubExplainedStep',
  props: {
    num: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.step {
  display: flex;
  flex-direction: row;
  padding-right: 16px;
  margin-bottom: 16px;

  .num {
    font-size: calc-font-size(24);
    font-weight: 600;
    margin-right: 12px;
  }

  .text {
    font-weight: 300;
    color: color('text', 'light');
  }
}
</style>
